<template>
    <div>
        <file-pond
                name="test"
                ref="pond"
                label-idle="Arraste ou clique aqui..."
                v-bind:allow-multiple="multiple"
                accepted-file-types="image/jpeg, image/png"
                server=""
                :maxFileSize="maxFileSize"
                labelMaxFileSizeExceeded="Tamanho máximo excedido"
                labelMaxFileSize="O tamanho máximo por arquivo é {filesize}"
                labelTapToUndo="desfazer"
                labelTapToCancel="cancelar"
                labelTapToRetry="reenviar"
                labelInvalidField="arquivos invalidos foram selecionados"
                labelFileLoadError="erro ao carregar"
                labelFileProcessing="enviando..."
                labelFileProcessingComplete="envio concluído"
                labelFileProcessingAborted="envio cancelado"
                labelFileProcessingError="erro durante o envio"
                labelFileProcessingRevertError="erro durante a reversão"
                labelFileRemoveError="erro durante a remoção"
                labelButtonRemoveItem="remover"
                labelButtonAbortItemLoad="abortar"
                labelButtonRetryItemLoad="reenviar"
                labelButtonAbortItemProcessing="cancelar"
                labelButtonUndoItemProcessing="desfazer"
                labelButtonRetryItemProcessing="reenviar"
                labelButtonProcessItem="enviar"
                instantUpload="false"
                :onupdatefiles="addFile"
                v-bind:files="myFiles">
        </file-pond>
    </div>
</template>

<script>
    import vueFilePond from 'vue-filepond';

    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileValidateSize);

    export default {
        components: {
            FilePond
        },
        props : {
            maxFileSize: String,
            multiple: {
                default: true
            }
        },
        data() {
            return {
                myFiles: [],
            }
        },
        methods: {
            addFile(files) {
                this.$emit('filesChanged', files);
                this.trick();
            },
            trick() {
                $('button.filepond--action-process-item').replaceWith('' +
                    '<button class="filepond--file-action-button filepond--action-process-item favoritar" type="button" data-align="right" style="transform:translate3d(0px, 0px, 0) scale3d(1, 1, 1) ;opacity:1;">' +
                    '<i class="far far-star-o"></i>' +
                    '</button>');
            },
        },
    };

   $(document).ready(function () {
       $(document.body).on('click', '.favoritar', function () {
           $('.favoritar i').each(function () {
               $(this).removeClass('fa-star');
           });

           $(this).children(':first').removeClass('far far-star-o');
           $(this).children(':first').addClass('fa fa-star');

           $('#foto_principal').val($(this).closest('li').index());
       })
   });
</script>

<style>
    .filepond--root {
        margin-top: 10%;
    }
</style>